export default "__VITE_ASSET__MeMipveh__"